import React, { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import { PageHeader } from '@/components/ui-kit/PageBits';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from '@/components/ui/dialog';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { toast } from 'sonner';
import { Plus } from 'lucide-react';

export default function TeacherAssignments() {
  const [items, setItems] = useState([]);
  const [groups, setGroups] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ title:'', description:'', type:'exercise', points:10, group_id:'' });
  const load = () => api.get('/assignments').then(r => setItems(r.data));
  useEffect(() => { load(); api.get('/groups').then(r => setGroups(r.data)); }, []);
  const submit = async () => {
    try {
      await api.post('/assignments', { ...form, points: Number(form.points), group_id: form.group_id || null });
      toast.success('Tarea creada');
      setOpen(false); setForm({title:'',description:'',type:'exercise',points:10,group_id:''}); load();
    } catch { toast.error('Error'); }
  };
  return (
    <div className="p-8 max-w-5xl mx-auto">
      <PageHeader title="Tareas" subtitle="Asigna actividades a tus grupos"
        right={
          <Dialog open={open} onOpenChange={setOpen}>
            <DialogTrigger asChild>
              <Button data-testid="new-assignment-btn" className="rounded-full bg-blue-600 hover:bg-blue-700"><Plus className="w-4 h-4 mr-1"/>Nueva tarea</Button>
            </DialogTrigger>
            <DialogContent>
              <DialogHeader><DialogTitle>Crear tarea</DialogTitle></DialogHeader>
              <div className="space-y-3">
                <Input data-testid="assignment-title" placeholder="Título" value={form.title} onChange={(e)=>setForm({...form,title:e.target.value})}/>
                <Textarea placeholder="Descripción" value={form.description} onChange={(e)=>setForm({...form,description:e.target.value})}/>
                <div className="grid grid-cols-3 gap-2">
                  <Select value={form.type} onValueChange={(v)=>setForm({...form,type:v})}>
                    <SelectTrigger><SelectValue/></SelectTrigger>
                    <SelectContent>
                      {['exercise','quiz','pgn_analysis','reading','video','custom'].map(t => <SelectItem key={t} value={t}>{t}</SelectItem>)}
                    </SelectContent>
                  </Select>
                  <Input type="number" placeholder="Puntos" value={form.points} onChange={(e)=>setForm({...form,points:e.target.value})}/>
                  <Select value={form.group_id} onValueChange={(v)=>setForm({...form,group_id:v})}>
                    <SelectTrigger><SelectValue placeholder="Grupo"/></SelectTrigger>
                    <SelectContent>
                      {groups.map(g => <SelectItem key={g.id} value={g.id}>{g.name}</SelectItem>)}
                    </SelectContent>
                  </Select>
                </div>
              </div>
              <DialogFooter><Button data-testid="assignment-save" onClick={submit}>Crear</Button></DialogFooter>
            </DialogContent>
          </Dialog>
        }
      />
      <div className="rounded-2xl bg-white border border-slate-200 divide-y">
        {items.length === 0 ? <div className="p-6 text-sm text-slate-500">Sin tareas.</div> :
          items.map(a => (
            <div key={a.id} className="p-5 flex items-center justify-between">
              <div>
                <div className="font-display font-bold">{a.title}</div>
                <div className="text-sm text-slate-500">{a.type} · {a.description}</div>
              </div>
              <div className="font-mono font-bold text-amber-600">+{a.points}</div>
            </div>
          ))}
      </div>
    </div>
  );
}
